module.exports = __webpack_public_path__ + "static/media/ic_appreciation_red.16e35eed.svg";